import React from 'react';

import { Grid, Typography, Tooltip } from '@gogame/components';

import { StatisticProgress } from './StatisticProgress';

export const MarksStatisticItem = ({ mark, value, count }) => {
  return (
    <Grid container alignItems={'center'} spacing={1}>
      <Grid item>
        <Typography
          component={'div'}
          variant={'caption'}
          color={'textSecondary'}
        >
          {mark}
        </Typography>
      </Grid>

      <Grid item xs container direction={'column'}>
        <Tooltip
          title={count ? `${count} ${count > 1 ? 'reviews' : 'review'}` : null}
        >
          <Grid item container direction={'column'}>
            <StatisticProgress value={value} />
          </Grid>
        </Tooltip>
      </Grid>
    </Grid>
  );
};
